module.exports = __WEBPACK_EXTERNAL_MODULE_83__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/observable/fromEvent","commonjs2":"rxjs/add/observable/fromEvent","amd":"rxjs/add/observable/fromEvent"}
// module id = 83
// module chunks = 0 1